(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/modals/_unarchive_class_confirm.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop\" role=\"dialog\"></div>\n<div class=\"comet-modal js-comet-modal\" role=\"document\" tabindex=\"0\">\n    <div id=modal-default class=\"comet-modal__inner\">\n        <div class=\"comet-modal__header comet-long-form-text\">\n            <h3 class=\"comet-modal__header-content\">Unarchive Class?</h3>\n        </div>\n        <div class=\"comet-modal__content comet-long-form-text\">\n            Are you sure you want to unarchive this class?\n        </div>\n        <div class=\"comet-modal__footer\">\n            <div class=\"comet-modal__button-row\">\n                <form method=\"POST\" action=\"/classrooms/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classGuid"), env.opts.autoescape);
output += "/unarchive\">\n                    <input type=\"hidden\" name=\"token\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "unarchive_class_token"), env.opts.autoescape);
output += "\">\n                    <input type=\"hidden\" name=\"next_endpoint\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "endpointShortname"), env.opts.autoescape);
output += "\">\n                    <input type=\"hidden\" name=\"next\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nextUrl"), env.opts.autoescape);
output += "\">\n                    <button type=\"button\" class=\"comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel js-comet-modal__close-button\">Cancel</button>\n                    <button type=\"submit\" class=\"comet-button comet-button--danger comet-modal__button comet-modal__button--confirm\">Unarchive Class</button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/modals/_unarchive_class_confirm", function(){});

